/* eslint-disable no-restricted-properties */
import {
  Classes,
  RangeSlider,
  RangeSliderProps,
  Slider,
  SliderProps,
} from "@blueprintjs/core";
import { darken } from "polished";
import styled, { css } from "styled-components";

const sliderStyles = css<Pick<HexSliderProps, "$small">>`
  && {
    .${Classes.SLIDER_TRACK} {
      height: 4px;

      > .${Classes.SLIDER_PROGRESS} {
        height: 4px;

        background-color: ${({ theme }) =>
          darken(0.1, theme.backgroundColor.MUTED)};

        &.${Classes.INTENT_PRIMARY} {
          background-color: ${({ theme }) => theme.intent.PRIMARY};
        }
      }
    }

    .${Classes.SLIDER_LABEL} {
      /* The horizontal padding on regular slider labels doesn't seem to do much of anything
       except cause horizontal overflow, so we remove it. */
      padding-right: 0;
      padding-left: 0;

      color: ${({ theme }) => theme.fontColor.MUTED};
    }

    .${Classes.SLIDER_HANDLE} {
      width: 14px;
      height: 14px;

      background-color: ${({ theme }) => theme.colors.WHITE};
      background-image: none;
      box-shadow: 0 0 0 1px ${({ theme }) => theme.boxShadow.BUTTON};

      .${Classes.SLIDER_LABEL} {
        margin-left: 7px;
        padding: 2px 3px;

        color: ${({ theme }) => theme.colors.WHITE};

        box-shadow: none;
      }
    }

    ${({ $small }) =>
      $small &&
      `
      height: 30px;

      .${Classes.SLIDER_LABEL} {
        transform: translate(-50%, 16px);
      }

      .${Classes.SLIDER_HANDLE} {
        width: 12px;
        height: 12px;

        .${Classes.SLIDER_LABEL} {
          margin-left: 6px;
        }
      }
    `}
  }
`;

export interface HexSliderProps extends SliderProps {
  $small?: boolean;
}

/**
 * https://blueprintjs.com/docs/#core/components/sliders
 */
export const HexSlider = styled(Slider as React.ComponentType<HexSliderProps>)`
  ${sliderStyles}
`;

export interface HexRangeSliderProps extends RangeSliderProps {
  $small?: boolean;
}

/**
 * https://blueprintjs.com/docs/#core/components/sliders.range-slider
 */
export const HexRangeSlider = styled(
  RangeSlider as React.ComponentType<HexRangeSliderProps>,
)`
  ${sliderStyles}

  .${Classes.SLIDER_HANDLE}.${Classes.END} {
    margin-left: 0;
  }
`;
